import { observer } from 'mobx-react';
import styles from './UltraSwitch.module.scss';
import { useEffect, useRef } from 'react';
import { summaryStore } from '../../../store';

const UltraSwitch = observer(() => {
    const normalRef = useRef(null);
    const ultraRef = useRef(null);

    const handleToggle = (mode) => {
        if (
            (mode === 'normal' && !summaryStore.useUltra) ||
            (mode === 'ultra' && summaryStore.useUltra)
        ) {
            return;
        }
        summaryStore.toggleUseUltra();
    };

    // 键盘支持
    useEffect(() => {
        const handleKeyDown = (e, mode) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleToggle(mode);
            }
        };
        const normalEl = normalRef.current;
        const ultraEl = ultraRef.current;
        if (normalEl) normalEl.addEventListener('keydown', (e) => handleKeyDown(e, 'normal'));
        if (ultraEl) ultraEl.addEventListener('keydown', (e) => handleKeyDown(e, 'ultra'));
        return () => {
            if (normalEl)
                normalEl.removeEventListener('keydown', (e) => handleKeyDown(e, 'normal'));
            if (ultraEl) ultraEl.removeEventListener('keydown', (e) => handleKeyDown(e, 'ultra'));
        };
    }, []);

    return (
        <div className={styles.switchWrapper}>
            <div className={styles.switchContainer}>
                <div className={styles.switchTrack}>
                    <div
                        className={`${styles.slider} ${summaryStore.useUltra ? styles.ultraActive : styles.normalActive}`}
                    />

                    <div
                        ref={normalRef}
                        className={`${styles.switchOption} ${!summaryStore.useUltra ? styles.active : ''}`}
                        onClick={() => handleToggle('normal')}
                    >
                        学术模型
                    </div>

                    <div
                        ref={ultraRef}
                        className={`${styles.switchOption} ${summaryStore.useUltra ? styles.active : ''}`}
                        onClick={() => handleToggle('ultra')}
                    >
                        <span className={styles.ultraLabel}>
                            超级自研学术模型
                            {/* ⬇️ 修改这里：去掉条件判断，让星星一直都在，只是样式受父级 .active 控制 */}
                            <span className={styles.starIcon}>✨</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default UltraSwitch;
